import { QuestionsApi, snapShootToArray } from './helpers/DatabaseHelpers'





export async function getQuestions() {
  const snapShoot = await QuestionsApi.once('value')
  return {
    status: "success",
    data: snapShootToArray(snapShoot)
  }
}



// WEBPACK FOOTER //
// ./src/Api.js